module.exports = __webpack_public_path__ + "static/img/bg_Department_normal@2x.b21cddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_Department_normal@2x.png
// module id = QSPL
// module chunks = 1